// frontend/src/components/games/tictactoe/TicTacToeModeSelector.tsx

import { TicTacToeMode } from './tictactoeConstants';

interface TicTacToeModeSelectorProps {
  current: TicTacToeMode;
  onSelect: (mode: TicTacToeMode) => void;
}

export function TicTacToeModeSelector({ current, onSelect }: TicTacToeModeSelectorProps) {
  return (
    <div className="ttt-mode-selector">
      <button
        type="button"
        className={`ttt-mode-btn ${current === 'two-player' ? 'active' : ''}`}
        onClick={() => onSelect('two-player')}
      >
        👥 İki Oyunculu
      </button>
      <button
        type="button"
        className={`ttt-mode-btn ${current === 'vs-ai' ? 'active' : ''}`}
        onClick={() => onSelect('vs-ai')}
      >
        🤖 Bilgisayara Karşı
      </button>
    </div>
  );
}
